// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.text-field[data-v-497eea1a] {\n  width: 45px;\n}\n", ""]);
// Exports
module.exports = exports;
